<template>
  <nav aria-label="Progress" class="mb-4">
    <ol class="flex items-center">
      <li
        v-for="(step, index) in steps"
        :key="step.label"
        class="relative flex-1"
        :class="{ 'pr-4': index < steps.length - 1 }"
      >
        <div class="flex items-center">
          <!-- Step circle -->
          <span
            class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-colors duration-200"
            :class="stepClasses(step, index)"
          >
            <CheckIcon v-if="step.completed" class="h-4 w-4" />
            <span v-else>{{ index + 1 }}</span>
          </span>
          <!-- Step label -->
          <span
            class="ml-2 text-sm font-medium whitespace-nowrap"
            :class="step.completed ? 'text-indigo-700' : step.active ? 'text-gray-900' : 'text-gray-400'"
          >
            {{ step.label }}
          </span>
          <!-- Connector line -->
          <div
            v-if="index < steps.length - 1"
            class="ml-3 h-0.5 flex-1"
            :class="step.completed ? 'bg-indigo-600' : 'bg-gray-200'"
          />
        </div>
      </li>
    </ol>
  </nav>
</template>

<script setup>
import { CheckIcon } from "@heroicons/vue/24/solid";

defineProps({
  steps: {
    type: Array,
    required: true,
    // Each step: { label: string, completed: boolean, active: boolean }
  },
});

const stepClasses = (step) => {
  if (step.completed) {
    return "bg-indigo-600 text-white";
  }
  if (step.active) {
    return "border-2 border-indigo-600 bg-white text-indigo-600";
  }
  return "border-2 border-gray-300 bg-white text-gray-400";
};
</script>
